import backgroundImage from 'assets/background/martonticket_404_pattern_w_bg.png'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh; /* Full viewport height */
    margin: auto;
    background-color: #ba9d31;
    background-image: url(${backgroundImage});
    background-size: cover;
    background-repeat: repeat;
    margin-bottom: -2rem;
`

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -15%;
`

export const Header = styled.h1`
    font-family: 'Poppins', sans-serif;
    font-weight: 800;
    text-align: center;
`

export const Description = styled.div`
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    text-align: center;
    max-width: 30rem;
    margin: 0 auto;
    margin-bottom: 2rem;
`
